// @flow

import moment from 'moment';

import Utils from '../../utils/Utils';

import ApiObject from '../ApiObject';

/**
 * Defines a custom capacity for a slot.
 * See BookingDaySettings.
 */
export default class BookingSlotCapacitySettings extends ApiObject {

  /**
   * This value is front only.
   * @type {null}
   */
  id: string = Utils.generateUID();

  /**
   * Ms timestamp that represents the hour and minute.
   */
  hour: number = 0;

  /**
   * The specific capacity for the slot.
   */
  capacity: number = 0;

  /**
   * This value is front only. Help use to know at which room this setting is attached.
   * @type {null}
   */
  roomId: ?string = null;

  /**
   * This value is front only. Help us to know at which day this setting is attached.
   * @type {null}
   */
  day: ?number = null;

  /**
   * This value is front only. Help us to sort in the array.
   * @type {null}
   */
  date: number = moment().unix();
}
